import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {},
    queries: {
      retry: false,
      staleTime: Infinity,
      gcTime: 60 * 60 * 1000,
    },
  },
});

export default queryClient;
